import React from "react";
import TabsPurchaseSettings from "./TabsPurchaseSettings";

const PurchaseSettings = () => {
  return (
    <div>
      <TabsPurchaseSettings />
    </div>
  );
};

export default PurchaseSettings;
